export default __webpack_public_path__ + "static/media/the_magician.dcd09726.png";